import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const objcGenerator: LanguageGenerator = {
  id: 'objc',
  name: 'Objective-C',
  category: 'request-examples',
  color: '#438EFF',
  generate(config: ExportConfig): GeneratedFile[] {
    const requestBlocks = config.apps
      .flatMap((a) =>
        a.templates.map((t) => {
          const exampleData = t.schema
            ? t.schema.reduce<Record<string, unknown>>((acc, f) => {
                acc[f.key] = f.type === 'number' ? Number(f.example || 0) : f.type === 'boolean' ? true : (f.example || f.key);
                return acc;
              }, {})
            : {};
          return [
            `    // Send: ${t.name}`,
            `    {`,
            `        NSURL *url = [NSURL URLWithString:[NSString stringWithFormat:@"%@/v1/send", serviceURL]];`,
            `        NSMutableURLRequest *req = [NSMutableURLRequest requestWithURL:url];`,
            `        req.HTTPMethod = @"POST";`,
            `        [req setValue:@"application/json" forHTTPHeaderField:@"Content-Type"];`,
            `        [req setValue:${a.key}Key forHTTPHeaderField:@"X-API-KEY"];`,
            `        NSDictionary *body = @{`,
            `            @"template_slug": @"${t.slug}",`,
            `            @"recipient": @"user@example.com",`,
            `            @"data": @{${Object.entries(exampleData).map(([k, v]) => `@"${k}": @"${v}"`).join(', ')}}`,
            `        };`,
            `        req.HTTPBody = [NSJSONSerialization dataWithJSONObject:body options:0 error:nil];`,
            `        [[NSURLSession.sharedSession dataTaskWithRequest:req completionHandler:^(NSData *d, NSURLResponse *r, NSError *e) {`,
            `            if (d) NSLog(@"%@", [[NSString alloc] initWithData:d encoding:NSUTF8StringEncoding]);`,
            `        }] resume];`,
            `    }`,
          ].join('\n');
        }),
      )
      .join('\n\n');

    const keyDecls = config.apps
      .map((a) => `    NSString *${a.key}Key = [NSProcessInfo.processInfo.environment objectForKey:@"${a.envVarName}"];`)
      .join('\n');

    const content = `// mail_requests.m — generated by Mail Service SDK Export
#import <Foundation/Foundation.h>

int main(int argc, const char *argv[]) {
    @autoreleasepool {
        NSString *serviceURL = [NSProcessInfo.processInfo.environment objectForKey:@"${config.serviceUrlVarName}"];
${keyDecls}

${requestBlocks}

        // Keep process alive for async requests
        [[NSRunLoop mainRunLoop] runUntilDate:[NSDate dateWithTimeIntervalSinceNow:5]];
    }
    return 0;
}
`;

    return [
      { filename: 'mail_requests.m', content, syntax: 'objective-c' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
